export function selectIsFeatureEnabled(id) {
  return (state) =>
    Object.prototype.hasOwnProperty.call(state.features.map, id) &&
    state.features.map[id] === true;
}
